export enum DATE_RANGE_TYPE {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
  ALL = 'all',
}

export enum DATE_UNITS {
  HOURS = 'hours',
  DAYS = 'days',
  MONTHS = 'months',
}

interface GenericDateRange<T extends DATE_RANGE_TYPE> {
  type: T;
  autoSelectedConstraint?: MinimalDateConstraint; // In certain case, we need to change the date automatically based on constraints like clicked element filter
}

export interface AbsoluteDateRange extends GenericDateRange<DATE_RANGE_TYPE.ABSOLUTE> {
  from: Date;
  to: Date;
}

export interface RelativeDateRange extends GenericDateRange<DATE_RANGE_TYPE.RELATIVE> {
  amount: number;
  unit: DATE_UNITS;
}

export type AllDateRange = GenericDateRange<DATE_RANGE_TYPE.ALL>;

export type DateRange = RelativeDateRange | AbsoluteDateRange | AllDateRange;

export interface MinimalDateConstraint {
  minDate: Date;
  formattedMinDate?: string;
  isFilterRelated?: boolean;
  reason: string;
  link?: {
    text: string;
    href: string;
  };
}
